import React from 'react'
import Header from '../components/Header'
import MyCarreer from '../components/MyCarreer'

function Carreer() {
    return (
        <>
            <Header />
            <MyCarreer />
        </>
    )
}

export default Carreer